import { LoadSTLModel } from '@xeokit/xeokit-sdk';

export async function loadModelSTL(
  id: string,
  source: string,
  name: string,
  options?: {
    edges?: boolean;
    pbr?: boolean;
    position?: (number | null | undefined)[];
    rotation?: (number | null | undefined)[];
    scale?: (number | null | undefined)[];
  },
): Promise<string | undefined> {
  const viewerStore = useViewerStore();
  const loader = viewerStore.getLoaders().stlLoaderPlugin;

  if (!viewerStore.isInitialized || !loader) return;

  const t0 = performance.now();

  const loaderOptions: LoadSTLModel = {
    id,
    src: source,
    edges: options?.edges ?? false,
  };

  const sceneModel = loader.load(loaderOptions);

  return new Promise((resolve, reject) => {
    sceneModel.on('loaded', function () {
      console.log(`Model loaded in ${Math.floor(performance.now() - t0) / 1000.0} seconds`);

      if (options) {
        updateModel(sceneModel, {
          position: options.position,
          // rotation: options.rotation,
          // scale: options.scale,
        });
      }
      viewerStore.saveModelMemento(sceneModel.id);
      resolve(sceneModel.id);
    });

    sceneModel.on('error', function (error) {
      console.error(error);
      reject(error);
    });
  });
}
